<script>
import {passingValuesToOfferAndRedirect} from "@/paths/helpers";
import {mapState} from "vuex";

export default {
  name: "FluentRedirectPage",

  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    },
  },

  /*
  * When an affid = 11 is present in the url we must show this page instead of the normal leave-behind ads page, once
  * the user has visited the page, after 2.5 seconds we will be auto redirected using the return link
  */
  data() {
    return {
      passingValuesToOfferAndRedirect,
      loading: true,
      jornayaLeadidToken: "",
      trustedFormId: "",
      trustedFormUrl: ""
    }
  },

  computed: {
    ...mapState([
      "fields",
      "highRisk"
    ]),
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search)

    if (this.prepare) {
      this.$emit('show-this-step')
      return
    }

    //destroy the callus now number in footer before component is created
    const callUsFooter = document.querySelector('.callUs')
    callUsFooter.style.display = 'none'

    let campaignId = 3499
    let supplierId = 5948
    let key = '7drtd35ce6x'

    const lpCampaignIdFromUrl = urlParams.get('lp_campaign_id')
    const lpSupplierIdFromUrl = urlParams.get('lp_supplier_id')
    const keyFromUrl = urlParams.get('lp_key')

    //overwrite lp campaign id, supplier id, or and key if present in URL
    if (lpCampaignIdFromUrl !== null && lpSupplierIdFromUrl !== null && keyFromUrl !== null) {
      campaignId = lpCampaignIdFromUrl
      supplierId = lpSupplierIdFromUrl
      key = keyFromUrl
    }

    this.$store.dispatch('setAnswers', [
      {
        field: "lp_campaign_id",
        value: campaignId,
      },
      {
        field: "lp_supplier_id",
        value: supplierId,
      },
      {
        field: "lp_key",
        value: key,
      },
    ])
  },

  mounted() {
    if (!this.prepare) {
      this.setTrustedFormAndJornaya();
      this.postData();
    }
  },

  methods: {
    async postData() {
      const params = {
        ...this.fields,
      };

      window.localStorage.removeItem('fields')

      setTimeout(() => {
        this.loading = false
        passingValuesToOfferAndRedirect()
      }, 2500)

      if (this.highRisk) return

      this.axios
        .post("https://api.leadprosper.io/ingest", params)
        .then((response) => {
          console.log("Submit Success", response);
        })
        .catch((e) => {
          console.log("error ", e);
        });
    },

    setTrustedFormAndJornaya() {
      this.getJornayaLeadIdToken();
      this.getTrustedForm();
      this.$store.dispatch("setAnswers", [
        {
          field: "leadid_token",
          value: this.jornayaLeadidToken,
        },
        {
          field: "xxtrustedformcert",
          value: this.trustedFormId,
        },
        {
          field: "xxTrustedFormCertUrl",
          value: this.trustedFormUrl,
        },
      ]);
    },

    getJornayaLeadIdToken() {
      this.jornayaLeadidToken = document.getElementById("leadid_token").value;
    },

    getTrustedForm() {
      let tfCertUrl = document.getElementById("xxCertUrl_0").value;
      let tfParts = tfCertUrl.split("https://cert.trustedform.com/");
      this.trustedFormUrl = tfCertUrl;
      this.trustedFormId = tfParts[1];
    },
  },
}
</script>

<style lang="scss" scoped>
.fluent-redirect-container {
  margin-top: 50px;
}

.fluent-redirect-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 420px;
}

.fluent-redirect-img {
  width: 100%;
  max-width: 800px;
}

.subtitle-under-loading {
  margin-top: 55px;
}

.loading-container {
  position: relative;
  width: 300px;
  height: 100px;
}

.text-color-accent {
  color: #e22766;
}

@media (max-width: 600px) {
  .fluent-redirect-container {
    margin-top: 0;
  }
  .subtitle-under-loading {
    margin-top: 10px;
  }
}
</style>

<template>
  <div v-if="!prepare">
    <div class="fluent-redirect-container is-max-widescreen px-5">
      <div class="box has-text-centered item-box">

        <div
          class="fluent-redirect-content"
        >
          <h2 class="title is-1 mb-5 is-spaced">
            Thanks for your <span class="text-color-accent">submission</span>!
          </h2>
          <h2 class="subtitle-under-loading subtitle is-5">
            You're still eligible for your reward from <span class="text-color-accent has-text-weight-semibold">Rewards Giant</span>.
          </h2>
          <h2 class="subtitle is-5">
            Complete your rewards entry now!
          </h2>
          <h2
            class="heading mb-3"
          >
            Please wait as you will be redirected to complete your rewards entry...
          </h2>
          <div class="loading-container">
            <b-loading
              :active="loading === true"
              :can-cancel="false"
              :is-full-page="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>